import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d1d0dcef00985f58881070f711a10429.jpg"
          alt="Productos personalizados Printven LLC"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1628]/95 via-[#0A1628]/80 to-[#0A1628]/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-24 pt-32 md:pt-40">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 border border-[#FF6B35]/60 rounded-full px-4 py-1.5 mb-5 md:mb-6">
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full flex-shrink-0"></div>
            <span className="text-[#FF6B35] text-xs md:text-sm font-medium">{t('hero.badge')}</span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-6xl font-extrabold text-white leading-tight mb-5 md:mb-6">
            {t('hero.title1')}{' '}
            <span className="text-[#FF6B35]">{t('hero.title2')}</span>
          </h1>

          <p className="text-white/70 text-base md:text-xl leading-relaxed mb-8 md:mb-10 max-w-xl">
            {t('hero.subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap gap-3 md:gap-4">
            <Link
              to="/servicios"
              className="inline-flex items-center justify-center gap-2 bg-[#FF6B35] text-white font-bold px-6 md:px-8 py-3.5 md:py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#e85a24] transition-all duration-200 text-sm md:text-base"
            >
              {t('hero.cta_quote')}
              <i className="ri-arrow-right-line text-base md:text-lg"></i>
            </Link>
            <a
              href="https://wa.me/17542034748"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold px-6 md:px-8 py-3.5 md:py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#1ebe5a] transition-all duration-200 text-sm md:text-base"
            >
              <i className="ri-whatsapp-line text-base md:text-lg"></i>
              {t('hero.cta_whatsapp')}
            </a>
            <a
              href="tel:+17542034748"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white font-bold px-6 md:px-8 py-3.5 md:py-4 rounded-full whitespace-nowrap cursor-pointer hover:border-white hover:bg-white/10 transition-all duration-200 text-sm md:text-base"
            >
              <i className="ri-phone-line text-base md:text-lg"></i>
              {t('hero.cta_contact')}
            </a>
          </div>

          <div className="flex flex-wrap gap-6 md:gap-8 mt-10 md:mt-14">
            {[
              { value: '30+', key: 'hero.stat1' },
              { value: '5+', key: 'hero.stat2' },
              { value: '100%', key: 'hero.stat3' },
            ].map((stat) => (
              <div key={stat.key}>
                <div className="text-2xl md:text-3xl font-extrabold text-[#FF6B35]">{stat.value}</div>
                <div className="text-white/60 text-xs md:text-sm mt-1">{t(stat.key)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs">{t('hero.scroll')}</span>
        <i className="ri-arrow-down-line text-white/40 text-xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
